import React from 'react';
import clsx from 'clsx';
import Depot from '../_shared/depot';
import * as styles from './style.module.css';
import Message, { MessageMood } from '../Messages/Message';
import Paragraph from '../Typography/Paragraph';
export const tagAllowedMoods = [
    MessageMood.PRIMARY,
    MessageMood.SECONDARY,
    MessageMood.NEUTRAL,
    MessageMood.INFO,
    MessageMood.POSITIVE,
    MessageMood.WARNING,
    MessageMood.NEGATIVE,
];
export const tagAllowedFlushes = ['top', 'right', 'bottom', 'left'];
export const tagAllowedAlignIconTypes = ['leading', 'trailing'];
const TagWithoutRef = ({ label, mood, flush, icon: Icon, alignIcon = 'leading', typeStyle = 'body', onClick, className, ...commonProps }) => {
    const smallTypeStyles = typeStyle === 'micro' || typeStyle === 'mini';
    // Styling
    const buttonClasses = clsx(className, onClick && styles.onClick);
    const tagClasses = clsx(styles.tag, smallTypeStyles && styles.smallSpacing, flush === 'top' && styles.flushTop, flush === 'right' && styles.flushRight, flush === 'bottom' && styles.flushBottom, flush === 'left' && styles.flushLeft);
    const messageClasses = clsx(styles.label);
    // Accessibility
    const ariaLabel = label
        ? { 'aria-labelledby': label }
        : { 'aria-label': 'Tag' };
    return Depot.createElement(onClick ? 'button' : 'div', { ...commonProps, className: buttonClasses, onClick }, React.createElement(Message, { className: tagClasses, mood: mood, ...ariaLabel },
        Icon && alignIcon === 'leading' && React.createElement(Icon, { size: 24 }),
        React.createElement(Paragraph, { typeStyle: typeStyle, fontWeight: "semibold", className: messageClasses }, label),
        Icon && alignIcon === 'trailing' && React.createElement(Icon, { size: 24 })));
};
const Tag = Depot.withRef(TagWithoutRef);
Tag.displayName = 'Tag';
export default Tag;
//# sourceMappingURL=index.js.map